import {
  MODIFIERS,
  V1_MODIFIER,
  MODIFIER_BY_ID,
  V1_DELETE_MODIFIER,
  V1_APPLY_TO_ITEMS,
  V1_SHOW_ITEM_MODIFIER,
  CREATE_ALL_OUTLET
} from './constants'

export function getModifiers (params) {
  return axios.get(MODIFIERS, {withCredentials: true, params})
    .then((res) => {
      return Promise.resolve(res)
    })
    .catch((error) => {
      let eobj
      if (error.response) {
        let data = error.response.data
        if (data.errors) {
          eobj = new Error(data.errors)
        } else if (data.message) {
          eobj = new Error(data.message)
        } else {
          eobj = new Error(error.message)
        }
      } else {
        eobj = new Error(error.message)
      }
      return Promise.reject(eobj)
    })
}

export function getModifiersV1 (params) {
  return axios.get(V1_MODIFIER, {withCredentials: true})
    .then((res) => {
      return Promise.resolve(res)
    })
    .catch((error) => {
      let eobj
      if (error.response) {
        let data = error.response.data
        if (data.errors) {
          eobj = new Error(data.errors)
        } else if (data.message) {
          eobj = new Error(data.message)
        } else {
          eobj = new Error(error.message)
        }
      } else {
        eobj = new Error(error.message)
      }
      return Promise.reject(eobj)
    })
}

export function getModifierById (id, params) {
  return axios.get(MODIFIER_BY_ID(id), {params, withCredentials: true})
    .then((res) => {
      return Promise.resolve(res)
    })
    .catch((error) => {
      let eobj
      if (error.response) {
        let data = error.response.data
        if (data.errors) {
          eobj = new Error(data.errors)
        } else if (data.message) {
          eobj = new Error(data.message)
        } else {
          eobj = new Error(error.message)
        }
      } else {
        eobj = new Error(error.message)
      }
      return Promise.reject(eobj)
    })
}

export function postModifier (data, params) {
  return axios.post(V1_MODIFIER, data, {params, withCredentials: true})
    .then((res) => Promise.resolve(res))
    .catch((error) => {
      let eobj
      if (error.response) {
        let data = error.response.data
        if (data.errors) {
          eobj = new Error(data.errors)
        } else if (data.message) {
          eobj = new Error(data.message)
        } else {
          eobj = new Error(error.message)
        }
      } else {
        eobj = new Error(error.message)
      }
      return Promise.reject(eobj)
    })
}

export function deleteModifier (id, params) {
  return axios.delete(V1_DELETE_MODIFIER(id), {params, withCredentials: true})
    .then((res) => Promise.resolve(res))
    .catch((error) => {
      let eobj
      if (error.response) {
        let data = error.response.data
        if (data.errors) {
          eobj = new Error(data.errors)
        } else if (data.message) {
          eobj = new Error(data.message)
        } else {
          eobj = new Error(error.message)
        }
      } else {
        eobj = new Error(error.message)
      }
      return Promise.reject(eobj)
    })
}

export function putModifier (id, data, params) {
  return axios.put(MODIFIER_BY_ID(id), data, {params, withCredentials: true})
    .then((res) => Promise.resolve(res))
    .catch((error) => {
      let eobj
      if (error.response) {
        let data = error.response.data
        if (data.errors) {
          eobj = new Error(data.errors)
        } else if (data.message) {
          eobj = new Error(data.message)
        } else {
          eobj = new Error(error.message)
        }
      } else {
        eobj = new Error(error.message)
      }
      return Promise.reject(eobj)
    })
}

export function postCreateAllOutlet (data, params) {
  return axios.post(CREATE_ALL_OUTLET, data, {params, withCredentials: true})
    .then((res) => Promise.resolve(res))
    .catch((error) => {
      let eobj
      if (error.response) {
        let data = error.response.data
        if (data.errors) {
          eobj = new Error(data.errors)
        } else if (data.message) {
          eobj = new Error(data.message)
        } else {
          eobj = new Error(error.message)
        }
      } else {
        eobj = new Error(error.message)
      }
      return Promise.reject(eobj)
    })
}

export function postApplyToItems (modifierId, data, params) {
  return axios.post(V1_APPLY_TO_ITEMS(modifierId), data, {params, withCredentials: true})
    .then((res) => Promise.resolve(res))
    .catch((error) => {
      let eobj
      if (error.response) {
        let data = error.response.data
        if (data.errors) {
          eobj = new Error(data.errors)
        } else if (data.message) {
          eobj = new Error(data.message)
        } else {
          eobj = new Error(error.message)
        }
      } else {
        eobj = new Error(error.message)
      }
      return Promise.reject(eobj)
    })
}

export function getShowItemModifer (modifierId, params) {
  return axios.get(V1_SHOW_ITEM_MODIFIER(modifierId), {params, withCredentials: true})
    .then((res) => Promise.resolve(res))
    .catch((error) => {
      let eobj
      if (error.response) {
        let data = error.response.data
        if (data.errors) {
          eobj = new Error(data.errors)
        } else if (data.message) {
          eobj = new Error(data.message)
        } else {
          eobj = new Error(error.message)
        }
      } else {
        eobj = new Error(error.message)
      }
      return Promise.reject(eobj)
    })
}



// WEBPACK FOOTER //
// ./app/api/modifiers/modifiers.js